<template>
  <div>
    <div>
      <div class="insurance-pdf">
        <h1>{{ $t("message.contracts.insurance_pdf_title") }}</h1>
        <h3>{{ $t("message.contracts.insurance_pdf_subtitle") }}</h3>
        <p class="font-style-italic">
          {{ $t("message.contracts.insurance_pdf_subsubtitle") }}
        </p>
        <br />
        <table cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <th>1</th>
              <td>
                {{ $t("message.contracts.insurance_pdf_0") }}
              </td>
              <td>
                {{ insurance.policy_holder_name }}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                {{ $t("message.contracts.insurance_pdf_0_1") }}
              </td>
              <td>
                {{ insurance.represented_by }}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                {{ $t("message.contracts.insurance_pdf_0_2") }}
              </td>
              <td>{{ insurance.legal_address }}</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                {{ $t("message.contracts.insurance_pdf_0_3") }}
              </td>
              <td>
                {{ insurance.actual_address }}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                {{ $t("message.contracts.insurance_pdf_0_4") }}
              </td>
              <td>
                <span v-if="insurance.is_public_person == 0">{{
                  $t("message.no")
                }}</span
                ><span v-else>{{ $t("message.yes") }}</span>
              </td>
            </tr>
            <tr>
              <th>2</th>
              <td>
                {{ $t("message.contracts.insurance_pdf_1") }}
              </td>
              <td>
                {{ insurance.insured_details }}
              </td>
            </tr>
            <tr>
              <th>3</th>
              <td>
                {{ $t("message.contracts.insurance_pdf_2") }}
              </td>
              <td>
                {{ insurance.insured_activity }}
              </td>
            </tr>
            <tr>
              <th>4</th>
              <td>
                {{ $t("message.contracts.insurance_pdf_3") }}
              </td>
              <td>
                {{ insurance.beneficiary }}
              </td>
            </tr>
            <tr>
              <th>5</th>
              <td>{{ $t("message.contracts.insurance_pdf_4") }}</td>
              <td>{{ insurance.beneficiary_details }}</td>
            </tr>
            <tr>
              <th>6</th>
              <td>{{ $t("message.contracts.insurance_pdf_5") }}</td>
              <td>{{ insurance.shipping_name }}</td>
            </tr>
            <tr>
              <th>7</th>
              <td>{{ $t("message.contracts.insurance_pdf_6") }}</td>
              <td>{{ insurance.package_info }}</td>
            </tr>
            <tr>
              <th>8</th>
              <td>{{ $t("message.contracts.insurance_pdf_7") }}</td>
              <td>{{ insurance.cargo_cost }}</td>
            </tr>
            <tr>
              <th>9</th>
              <td>{{ $t("message.contracts.insurance_pdf_8") }}</td>
              <td>{{ insurance.package_count }}</td>
            </tr>
            <tr>
              <th>10</th>
              <td>{{ $t("message.contracts.insurance_pdf_9") }}</td>
              <td>{{ insurance.total_cost }}</td>
            </tr>
            <tr>
              <th>11</th>
              <td>{{ $t("message.contracts.insurance_pdf_10") }}</td>
              <td>{{ insurance.release_date }}</td>
            </tr>
            <tr>
              <th>12</th>
              <td>{{ $t("message.contracts.insurance_pdf_11") }}</td>
              <td>
                {{
                  insurance.containerization == 1
                    ? $t("message.yes")
                    : $t("message.no")
                }}
              </td>
            </tr>
            <tr>
              <th>13</th>
              <td>{{ $t("message.contracts.insurance_pdf_12") }}</td>
              <td>{{ insurance.cargo_placing }}</td>
            </tr>
            <tr>
              <th>14</th>
              <td>{{ $t("message.contracts.insurance_pdf_13") }}</td>
              <td>{{ insurance.route }}</td>
            </tr>
            <tr>
              <th>15</th>
              <td>{{ $t("message.contracts.insurance_pdf_14") }}</td>
              <td>{{ insurance.security_measures }}</td>
            </tr>
            <tr>
              <th>16</th>
              <td>{{ $t("message.contracts.insurance_pdf_15") }}</td>
              <td>{{ insurance.transport_means }}</td>
            </tr>
            <tr>
              <th>17</th>
              <td>{{ $t("message.contracts.insurance_pdf_16") }}</td>
              <td>{{ insurance.transfer_points }}</td>
            </tr>
            <tr>
              <th>18</th>
              <td>{{ $t("message.contracts.insurance_pdf_17") }}</td>
              <td>{{ insurance.shipping_details }}</td>
            </tr>
            <tr>
              <th>19</th>
              <td>
                <p>{{ $t("message.contracts.insurance_pdf_18") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_19") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_20") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_21") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_22") }}</p>
              </td>
              <td>
                <p>&nbsp;</p>
                <p>{{ insurance.risk_a }}</p>
                <p>{{ insurance.risk_b1 }}</p>
                <p>{{ insurance.risk_b2 }}</p>
                <p>{{ insurance.additional_conditions }}</p>
              </td>
            </tr>
            <tr>
              <th>20</th>
              <td>
                <p>{{ $t("message.contracts.insurance_pdf_23") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_24") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_25") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_26") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_27") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_28") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_29") }}</p>
              </td>
              <td>
                <p>&nbsp;</p>
                <p>{{ insurance.max_value_a }}</p>
                <p>{{ insurance.max_value_b }}</p>
                <p>{{ insurance.max_value_c }}</p>
                <p>{{ insurance.max_value_d }}</p>
                <p>{{ insurance.max_value_e }}</p>
                <p>{{ insurance.max_value_f }}</p>
              </td>
            </tr>
            <tr>
              <th>21</th>
              <td>
                <p>{{ $t("message.contracts.insurance_pdf_30") }}</p>
                <p>{{ $t("message.contracts.insurance_pdf_31") }}</p>
              </td>
              <td>
                <p>{{ insurance.insured_transport }}</p>
                <p>{{ insurance.insured_transport_amount }}</p>
              </td>
            </tr>
            <tr>
              <th>22</th>
              <td>{{ $t("message.contracts.insurance_pdf_32") }}</td>
              <td></td>
            </tr>
            <tr>
              <th>23</th>
              <td>{{ $t("message.contracts.insurance_pdf_33") }}</td>
              <td>{{ insurance.franchise }}</td>
            </tr>
            <tr>
              <th>24</th>
              <td>{{ $t("message.contracts.insurance_pdf_34") }}</td>
              <td>{{ insurance.shipment_date }}</td>
            </tr>
            <tr>
              <th>25</th>
              <td>{{ $t("message.contracts.insurance_pdf_35") }}</td>
              <td>{{ insurance.shipment_duration }}</td>
            </tr>
            <tr>
              <th>26</th>
              <td>{{ $t("message.contracts.insurance_pdf_36") }}</td>
              <td>{{ insurance.insurance_stats }}</td>
            </tr>
            <tr>
              <th>27</th>
              <td>{{ $t("message.contracts.insurance_pdf_37") }}</td>
              <td>{{ insurance.relevant_info }}</td>
            </tr>
            <tr>
              <th>28</th>
              <td>{{ $t("message.contracts.insurance_pdf_38") }}</td>
              <td>{{ insurance.other }}</td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <h4>{{ $t("message.contracts.insurance_pdf_footer_title") }}</h4>
        <p class="indented">{{ $t("message.contracts.insurance_pdf_p_1") }}</p>
        <p class="indented">{{ $t("message.contracts.insurance_pdf_p_2") }}</p>
        <p class="indented">{{ $t("message.contracts.insurance_pdf_p_3") }}</p>
        <p class="indented">{{ $t("message.contracts.insurance_pdf_p_4") }}</p>
        <p class="indented">{{ $t("message.contracts.insurance_pdf_p_4") }}</p>
        <p class="indented">
          <b>{{ $t("message.contracts.insurance_pdf_p_6_b") }}</b>
          {{ $t("message.contracts.insurance_pdf_p_6") }}
        </p>
        <br /><br />
        <p>
          {{ $t("message.contracts.insurance_pdf_insurer") }}
          {{
            insurer.organizations && insurer.organizations.org_name
              ? insurer.organizations.org_name
              : ""
          }}
          {{ $t("message.contracts.insurance_pdf_date") }} «{{ day }}»
          {{ month }} {{ year }}
        </p>
        <br /><br />
        <p>{{ $t("message.contracts.insurance_pdf_footer1") }}</p>
        <br />
        <p>
          {{ $t("message.contracts.insurance_pdf_footer3") }}
          {{
            insurer.organizations && insurer.organizations.org_name
              ? insurer.organizations.org_name
              : ""
          }}
        </p>
      </div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
var QRCode = require("qrcode");
export default {
  name: "insurance",
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      insurance: {},
      insurer: {},
    };
  },
  mounted() {
    axios
      .get(
        window.base + "/Document/LoadInsurance/?doc_id=" + this.doc.DocumentID,
      )
      .then((response) => {
        this.insurance = response.data;
        axios
          .get(
            window.base +
              "/Document/GetInsurerByDoc/?document_id=" +
              this.doc.DocumentID,
          )
          .then((res) => {
            this.insurer = res.data;
            axios
              .get(
                window.base + "/document/LoadSignature?doc_id=" + this.doc_id,
              )
              .then((response) => {
                if (typeof response.data.signature !== "undefined") {
                  // console.log("as")
                  if (response.data.signature == "") {
                    this.$root.$emit("print-pdf", {
                      signature: "",
                      type: "insurance",
                    });
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$t("message.contracts.no-signature-message"),
                      timeout: 5000,
                    }).show();
                  } else {
                    var canvas = QRCode.toCanvas(response.data.signature, {
                      width: 100,
                      height: 100,
                    });
                    canvas.then((r) => {
                      // this.check_signature(value, ()=>{
                      this.$root.$emit("print-pdf", {
                        signature: r,
                        type: "insurance",
                      });
                      new Noty({
                        theme: "light",
                        type: "success",
                        text: this.$t(
                          "message.contracts.yes-signature-message",
                        ),
                        timeout: 5000,
                      }).show();
                      // window.webSocket.removeEventListener('message', {})
                      // })
                    });
                  }
                } else {
                  // console.log("bs")
                  this.$root.$emit("print-pdf", {
                    signature: "",
                    type: "insurance",
                  });
                  new Noty({
                    theme: "light",
                    type: "error",
                    text: this.$t("message.contracts.no-signature-message"),
                    timeout: 5000,
                  }).show();
                }
              });
          });
      });
  },
  methods: {
    getFullSum() {
      return (
        this.insurance.cargo_insured_sum +
        this.insurance.life_insured_sum +
        this.insurance.property_insured_sum
      );
    },
    getBankData() {
      if (typeof (this.insurer.banks[0] !== "undefined"))
        return (
          this.insurer.banks[0].subj_bank +
          ", " +
          this.insurer.banks[0].subj_bank_acc_number +
          ", " +
          this.insurer.banks[0].subj_bank_address
        );
    },
    getAddress() {
      if (typeof (this.insurer.addresses[0] !== "undefined"))
        return (
          this.insurer.addresses[0].post_addr_country +
          ", " +
          this.insurer.addresses[0].post_addr_region +
          ", " +
          this.insurer.addresses[0].post_addr_city +
          ", " +
          this.insurer.addresses[0].post_addr_streethouse +
          ", " +
          this.insurer.addresses[0].post_addr_house
        );
    },
  },
  computed: {
    day() {
      return moment(this.doc.DocumentDate).format("D");
    },
    month() {
      return moment(this.doc.DocumentDate).format("MMMM");
    },
    year() {
      return moment(this.doc.DocumentDate).format("Y");
    },
  },
};
</script>
<style scoped>
.insurance-pdf table {
  width: 100%;
}
.insurance-pdf table td,
.insurance-pdf table th {
  border: 1px solid #000;
  border-right: 0;
  border-bottom: 0;
  padding: 5px;
  font-size: 12px;
}
.insurance-pdf table tr > td:last-child {
  border-right: 1px solid #000;
}
.insurance-pdf table tr:last-child th,
.insurance-pdf table tr:last-child td {
  border-bottom: 1px solid #000;
}
.insurance-pdf h1 {
  font-size: 18px;
  margin-bottom: 0;
}
.insurance-pdf h2 {
  font-size: 16px;
  margin-bottom: 0;
}
.insurance-pdf h3,
.insurance-pdf h4 {
  font-size: 14px;
  margin-bottom: 0;
}

.insurance-pdf h1,
.insurance-pdf h3 {
  text-align: center;
}
.insurance-pdf p.font-style-italic {
  font-style: italic;
  text-align: center;
}
.insurance-pdf h4 {
  text-align: center;
  font-style: italic;
}
.insurance-pdf p {
  margin-bottom: 0;
}
.insurance-pdf p.indented {
  text-indent: 20px;
  font-style: italic;
  margin-bottom: 0;
  font-size: 12px;
}
</style>
